import React from 'react';
import { motion } from 'framer-motion';
import { Home, PawPrint } from 'lucide-react';
const sessions = [{
  icon: Home,
  eyebrow: 'Para tu entorno',
  title: 'Limpieza energética de espacios',
  description: 'Para hogares, oficinas o lugares que se sienten cargados, densos, alterados o energéticamente desordenados.',
  priceArs: '$55.000 ARS',
  priceUsd: 'USD 40 vía PayPal',
  waMessage: 'Hola%20Laura!%20Quiero%20coordinar%20una%20limpieza%20energ%C3%A9tica%20de%20espacios.'
}, {
  icon: PawPrint,
  eyebrow: 'Para tu compañero animal',
  title: 'Limpieza energética de animales',
  description: 'Los animales también perciben, absorben y expresan movimientos energéticos. Esta sesión incluye una evaluación energética personalizada para acompañar la depuración de aquello que pueda estar afectando su bienestar en el plano vibracional.',
  priceArs: '$60.000 ARS',
  priceUsd: 'USD 45 vía PayPal',
  waMessage: 'Hola%20Laura!%20Quiero%20coordinar%20una%20limpieza%20energ%C3%A9tica%20para%20mi%20animal.'
}];
export function SpecialSessions() {
  return <section className="w-full bg-cream py-24 px-6" data-id="element-464">
      <div className="max-w-6xl mx-auto" data-id="element-465">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-466">
          <h2 className="font-serif text-teal text-3xl md:text-4xl lg:text-5xl mb-6" data-id="element-467">
            Sesiones especiales
          </h2>
          <div className="space-y-4 max-w-2xl mx-auto text-gray-700 font-light leading-relaxed text-lg" data-id="element-468">
            <p data-id="element-469">
              No todo lo que necesita ser depurado se manifiesta únicamente en
              una persona.
            </p>
            <p data-id="element-470">
              A veces, el movimiento también aparece en un espacio o en un
              animal, pidiendo ser atendido desde otra sensibilidad.
            </p>
            <p className="font-serif italic text-teal-dark text-xl pt-2" data-id="element-471">
              Por eso, además de las sesiones individuales, también realizo
              trabajos especiales a distancia para:
            </p>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10" data-id="element-472">
          {sessions.map((session, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="flex flex-col bg-white border border-teal/20 rounded-2xl p-8 shadow-sm" data-id="element-473">
              <div className="w-14 h-14 rounded-full bg-teal/10 flex items-center justify-center mb-6" data-id="element-474">
                <session.icon className="text-teal" size={26} strokeWidth={1.5} data-id="element-475" />
              </div>

              <div className="text-teal font-serif uppercase tracking-widest text-xs mb-3" data-id="element-476">
                {session.eyebrow}
              </div>
              <h3 className="font-serif text-teal-dark text-2xl md:text-3xl mb-4" data-id="element-477">
                {session.title}
              </h3>
              <p className="text-gray-700 font-light leading-relaxed mb-8 flex-grow" data-id="element-478">
                {session.description}
              </p>

              <div className="border-t border-teal/15 pt-6 mb-8" data-id="element-479">
                <div className="text-teal-dark font-medium text-lg mb-1" data-id="element-480">
                  🇦🇷 {session.priceArs}
                </div>
                <div className="text-teal-dark font-medium text-lg" data-id="element-481">
                  🌎 {session.priceUsd}
                </div>
              </div>

              <a href={`https://wa.me/542616167908?text=${session.waMessage}`} target="_blank" rel="noopener noreferrer" className="w-full text-center bg-teal text-white py-4 rounded-full font-medium tracking-wide hover:bg-teal-dark transition-colors" data-id="element-482">
                AGENDAR SESIÓN
              </a>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="text-center font-serif italic text-gray-600 text-sm md:text-base max-w-2xl mx-auto leading-relaxed" data-id="element-483">
          Modalidad: estas sesiones se realizan a distancia y se coordinan de
          forma personalizada según cada caso.
        </motion.p>
      </div>
    </section>;
}